import { render, staticRenderFns } from "./ExerciseItemDetails.vue?vue&type=template&id=40d0a998&"
import script from "./ExerciseItemDetails.vue?vue&type=script&lang=js&"
export * from "./ExerciseItemDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports